import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

class UserGroupMembershipEnterpriseComponentMetadata extends EnterpriseComponentMetadata {

    constructor() {
        super();

        this.name = "UserGroupMembership";
        this.defaultCacheSize = 1000;

        this.attributes["SourceUSID"] = new EnterpriseComponentAttributeMetadata(
            "SourceUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null, // default value
            false, // computed
        );
        this.attributes["SourceType"] = new EnterpriseComponentAttributeMetadata(
            "SourceType", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        // WHY THE PLATFORM PUT THIS SHARE HERE, so the Visibility tab can say so. Read-only:
        // provenance is written by the granting engine and is what lets it take back only rows it
        // can prove are its own.
        this.attributes["GrantedByApprovalRequestUSID"] = new EnterpriseComponentAttributeMetadata(
            "GrantedByApprovalRequestUSID", // name
            true, // NoCopy
            true, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        // WHY THE PLATFORM PUT THIS SHARE HERE, so the Visibility tab can say so. Read-only:
        // provenance is written by the granting engine and is what lets it take back only rows it
        // can prove are its own.
        this.attributes["GrantedByTrainingCurriculumUSID"] = new EnterpriseComponentAttributeMetadata(
            "GrantedByTrainingCurriculumUSID", // name
            true, // NoCopy
            true, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        this.attributes["GrantedByFolderUSID"] = new EnterpriseComponentAttributeMetadata(
            "GrantedByFolderUSID", // name
            true, // NoCopy
            true, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        this.attributes["UserGroupUSID"] = new EnterpriseComponentAttributeMetadata(
            "UserGroupUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            "UserGroup", // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null, // default value
            false, // computed
        );
        this.attributes["UserGroupName"] = new EnterpriseComponentAttributeMetadata(
            "UserGroupName", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        this.attributes["PrimaryAccountUserUSID"] = new EnterpriseComponentAttributeMetadata(
            "PrimaryAccountUserUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null, // default value
            false, // computed
        );
        this.attributes["PrimaryAccountUserName"] = new EnterpriseComponentAttributeMetadata(
            "PrimaryAccountUserName", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100, // length
            null, // minLength
            null, // pattern
            "String", // Type
            null, // default value
            false, // computed
        );
        this.attributes["AccountUsers"] = new EnterpriseComponentAttributeMetadata(
            "AccountUsers", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "Array", // Type
            null, // default value
            false, // computed
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null, // length
            null, // minLength
            null, // pattern
            "Datetime", // Type
            null, // default value
            false, // computed
        );
        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            36, // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null, // default value
            false, // computed
        );
    }
}

export default UserGroupMembershipEnterpriseComponentMetadata;
